import RollingCountAnimation, { RollingCountAnimationProps } from './RollingCountAnimation'

type Props = Omit<RollingCountAnimationProps, 'rollingNumbers'> & {
  finalNumber: number
  rollingCount?: number
}

const MissionRollingCountAnimation = ({ ...props }: Props) => {
  const { finalNumber, rollingCount = 10 } = props

  const prevNumber = Math.max(0, finalNumber - 1)
  const rollingNumbers = Array(rollingCount - 1)
    .fill(finalNumber)
    .map((count, index) => count + index + 1)

  return <RollingCountAnimation rollingNumbers={[prevNumber, ...rollingNumbers, finalNumber]} {...props} />
}

export default MissionRollingCountAnimation
